import { FC } from 'react'

type Props = {
  isChecked: boolean
  handleCheckboxChange: () => void
  disabled?: boolean 
}

const Checkbox: FC<Props> = ({ isChecked, handleCheckboxChange, disabled }) => {
  return (
    <input
      type="checkbox"
      checked={isChecked}
      onChange={handleCheckboxChange}
      className="custom-checkbox"
      disabled={disabled}
    />
  )
}

export default Checkbox
